export default function IconEmail({ currentColor = 'black' }: { currentColor?: string }) {
  return (
    <svg width="17" height="12" viewBox="0 0 17 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15.4062 12H1.59375C0.711875 12 0 11.33 0 10.5V1.5C0 0.67 0.711875 0 1.59375 0H15.4062C16.2881 0 17 0.67 17 1.5V10.5C17 11.33 16.2881 12 15.4062 12ZM1.59375 1C1.29625 1 1.0625 1.22 1.0625 1.5V10.5C1.0625 10.78 1.29625 11 1.59375 11H15.4062C15.7037 11 15.9375 10.78 15.9375 10.5V1.5C15.9375 1.22 15.7037 1 15.4062 1H1.59375Z"
        fill={currentColor}/>
      <path
        d="M8.50062 7.95865C7.75687 7.95865 7.07687 7.67865 6.56687 7.16865L0.988745 1.58865C0.78687 1.38865 0.797495 1.06865 1.01 0.878654C1.2225 0.688654 1.5625 0.698654 1.76437 0.898654L7.34249 6.47865C7.94812 7.08865 9.05312 7.08865 9.65875 6.47865L15.2369 0.908654C15.4387 0.708654 15.7787 0.698654 15.9912 0.888654C16.2037 1.07865 16.2144 1.39865 16.0125 1.59865L10.4344 7.17865C9.92437 7.68865 9.24437 7.96865 8.50062 7.96865V7.95865Z"
        fill={currentColor}/>
    </svg>
  );
}
